import { render, staticRenderFns } from "./pointSetting_test.vue?vue&type=template&id=3c3910de&scoped=true"
import script from "./pointSetting_test.vue?vue&type=script&lang=js"
export * from "./pointSetting_test.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3910de",
  null
  
)

export default component.exports